import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import {
  Box,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@material-ui/core";
import AuditReportTableNew from "../PurchaseOrderDashbaordIndex/AuditReportTableNew";
import moment from "moment";

const renderPOStatusButton = (statusID, statusText) => {
  let color;
  switch (statusID) {
    case 21:
      color = "#B4B4B4";
      break;
    case 23:
      color = "#E78A00";
      break;
    case 22:
      color = "#2196F3";
      break;
    case 25:
    case 29:
    case 31:
    case 27:
      color = "#329429";
      break;
    case 30:
      color = "#707070";
      break;
    case 24:
      color = "#FF0000";
      break;
    default:
      color = "#1E1E1E";
  }
  return (
    <Typography
      variant="body1"
      style={{
        textAlign: "center",
        padding: "0.25rem",
        borderRadius: "0.45rem",
        fontSize: "0.875rem",
        color: "white",
        backgroundColor: color,
        border: `2px solid ${color}`,
        whiteSpace: "nowrap",
      }}
    >
      {statusText}
    </Typography>
  );
};

const useStyles = makeStyles((theme) => ({
  root: {
    padding: 0,
    backgroundColor: "#ffffff",
    minHeight: "100vh",
  },
  headerSection: {
    display: "flex",
    alignItems: "center",
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(3),
    backgroundColor: "#ffffff",
    borderBottom: "none",
    boxShadow: "none",
  },
  backButton: {
    display: "flex",
    alignItems: "center",
    marginRight: theme.spacing(2),
    cursor: "pointer",
    "&:hover": {
      borderBottom: "2px solid black",
    },
  },
  backIcon: {
    paddingLeft: theme.spacing(1),
    fontSize: "small",
    color: "#000",
    cursor: "pointer",
  },
  backText: {
    cursor: "pointer",
    fontWeight: 500,
    fontSize: "16px",
    color: "#000",
    marginLeft: theme.spacing(0.5),
  },
  headerTitle: {
    fontSize: "20px",
    fontWeight: 700,
    color: "#000",
    marginLeft: theme.spacing(2),
  },
  contentSection: {
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(6),
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(3),
  },
  headerDivider: {
    borderBottom: "1px solid #ddd",
    marginBottom: theme.spacing(1),
    marginTop: 0,
  },
  sectionTitle: {
    fontWeight: 500,
    fontSize: "1.5rem",
    textAlign: "left",
    paddingBottom: "0",
    marginTop: theme.spacing(3),
    marginBottom: "0",
    color: "#000",
    lineHeight: "1.2",
  },
  titleBorder: {
    border: "2px solid #707070",
    display: "flex",
    width: "1.6rem",
    backgroundColor: "#707070",
    marginBottom: theme.spacing(2),
    marginTop: "0.2rem",
  },
}));

export default function InactivePOHistoryDialog({
  rowInfo,
  setOpenPoHistory,
  poLineAuditsNewData,
  poLineAuditsNewDataLoading,
}) {
  const classes = useStyles();

  const sl = rowInfo?.scheduleLineDetails || {};

  // Build a modifiedRowInfo so AuditReportTableNew's refresh can find schrockenSLID
  const modifiedRowInfo = {
    ...rowInfo,
    scheduleLineDetails: {
      ...sl,
      schrockenSLID:
        sl.schrockenSLID || rowInfo?.schrockenSLID || "",
    },
  };

  const handleBack = () => {
    setOpenPoHistory(false);
  };

  return (
    <Box className={classes.root}>
      <Box className={classes.headerSection}>
        <div className={classes.backButton} onClick={handleBack}>
          <ArrowBackIosIcon className={classes.backIcon} />
          <Typography className={classes.backText}>Back</Typography>
        </div>
        <Typography className={classes.headerTitle}>
          Collaboration – Delivered/Deleted POs – View PO history
        </Typography>
      </Box>
      <Box className={classes.headerDivider}></Box>

      <Box style={{ textAlign: 'center' }}>
        <Typography style={{ fontFamily: "sans-serif", fontSize: "1.5rem" }}>Audit Report</Typography>
      </Box>
      <Box className={classes.contentSection}>
        <TableContainer component={Paper} style={{ backgroundColor: "#f2f8fb" }}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell style={{ fontWeight: "bold" }}>PO Number</TableCell>
                <TableCell style={{ fontWeight: "bold" }}>
                  Product Code / Description
                </TableCell>
                <TableCell style={{ fontWeight: "bold" }}>CMO</TableCell>
                <TableCell style={{ fontWeight: "bold" }}>
                  Date of Creation
                </TableCell>
                <TableCell style={{ fontWeight: "bold" }}>Created By</TableCell>
                <TableCell align="center" style={{ fontWeight: "bold" }}>
                  PO Status
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow>
                <TableCell>
                  {rowInfo?.poNumber || ""}
                </TableCell>
                <TableCell>
                  {rowInfo?.bmsProductCode || ""} /{" "}
                  <br />
                  {rowInfo?.bmsProductDescription || ""}
                </TableCell>
                <TableCell>{rowInfo.vendorName || ""}</TableCell>
                <TableCell>
                  {rowInfo?.creationDate
                    ? moment(rowInfo.creationDate)
                      .format("DD-MMM-YYYY")
                      .toUpperCase()
                    : ""}
                </TableCell>
                <TableCell>{rowInfo.userName || ""}</TableCell>
                <TableCell align="center">
                  <Box
                    style={{
                      display: "inline-block",
                    }}
                  >
                    {(rowInfo.poStatusID && rowInfo.scheduleLineStatusText) ? renderPOStatusButton(
                      rowInfo.poStatusID,
                      rowInfo.scheduleLineStatusText
                    ):""}
                  </Box>
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>


        <AuditReportTableNew
          poLineAuditsNewData={poLineAuditsNewData}
          poLineAuditsNewDataLoading={poLineAuditsNewDataLoading}
          rowInfo={modifiedRowInfo}
        />
      </Box>
    </Box>
  );
}
